import React, { createContext, useContext, useState, ReactNode } from 'react';
import { Lead } from '../types';

interface GlobalChatContextData {
  activeChatLead: Lead | null;
  openChat: (lead: Lead) => void;
  closeChat: () => void;
}

const GlobalChatContext = createContext<GlobalChatContextData>({} as GlobalChatContextData);

export function GlobalChatProvider({ children }: { children: ReactNode }) {
  const [activeChatLead, setActiveChatLead] = useState<Lead | null>(null);

  const openChat = (lead: Lead) => {
    setActiveChatLead(lead);
  };

  const closeChat = () => {
    setActiveChatLead(null);
  };

  return (
    <GlobalChatContext.Provider value={{ activeChatLead, openChat, closeChat }}>
      {children}
    </GlobalChatContext.Provider>
  );
}

export function useGlobalChat() {
  const context = useContext(GlobalChatContext);
  if (!context) {
    throw new Error('useGlobalChat must be used within a GlobalChatProvider');
  }
  return context;
}
